import client from '../client';
import endpoints from '../endpoints';

/* ── 서비스 (유저용) ── */

/** POST /api/inquiries */
export const createInquiry = async (data) => {
  const res = await client.post(endpoints.inquiries.create, data);
  return res.data;
};

/** GET /api/inquiries — 본인 문의 목록 */
export const getMyInquiries = async () => {
  const res = await client.get(endpoints.inquiries.list);
  return res.data;
};

/** GET /api/inquiries/:id — 본인 문의 상세 */
export const getMyInquiryById = async (id) => {
  const res = await client.get(endpoints.inquiries.detail(id));
  return res.data;
};

/* ── 관리자 ── */

/** GET /api/admin/inquiries */
export const getAdminInquiries = async (params = {}) => {
  const res = await client.get(endpoints.admin.inquiries.list, { params });
  return res.data;
};

/** GET /api/admin/inquiries/:id */
export const getAdminInquiryById = async (id) => {
  const res = await client.get(endpoints.admin.inquiries.detail(id));
  return res.data;
};

/** PUT /api/admin/inquiries/:id */
export const answerAdminInquiry = async (id, data) => {
  const res = await client.put(endpoints.admin.inquiries.detail(id), data);
  return res.data;
};
